'use client'

// React Imports
import { createContext, useContext } from 'react'
import type { ReactNode } from 'react'

// Config Imports
import { getBrand } from '@configs/brands'
import type { Brand } from '@configs/brands'

const BrandContext = createContext<Brand>(getBrand())

export const BrandProvider = ({ brand, children }: { brand: Brand; children: ReactNode }) => (
  <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>
)

export const useBrand = () => useContext(BrandContext)
